var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/chart"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.37508 12.9376C5.72925 16.4376 4.16675 20.7917 4.16675 25.5001C4.16675 37.0001 13.5001 46.3334 25.0001 46.3334C36.5001 46.3334 45.8334 37.0001 45.8334 25.5001C45.8334 14.0001 36.5001 4.66675 25.0001 4.66675",
    stroke: "#8BC63E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.4167 25.5001C10.4167 33.5626 16.9376 40.0834 25.0001 40.0834C33.0626 40.0834 39.5834 33.5626 39.5834 25.5001C39.5834 17.4376 33.0626 10.9167 25.0001 10.9167",
    stroke: "#8BC63E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M25 33.8334C29.6042 33.8334 33.3333 30.1042 33.3333 25.5001C33.3333 20.8959 29.6042 17.1667 25 17.1667",
    stroke: "#8BC63E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartIcon);
export default __webpack_public_path__ + "static/media/chart-icon.dac697f1eada513c9bf830a2420f425a.svg";
export { ForwardRef as ReactComponent };